const BaseModel = require('../BaseModel');

class OrganisationEntitlement extends BaseModel {
  static basePath = null;
  static dataType = 'organisation-entitlement';
}

BaseModel.models[OrganisationEntitlement.dataType] = OrganisationEntitlement;
module.exports = OrganisationEntitlement;
